import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Renders AI-generated markdown (headings, bold, lists, hr) as real
 * formatted text instead of literal "**bold**"/"## heading" characters.
 * NOTE: always uses the inverted (light-on-dark) palette - this app has no
 * Tailwind `.dark` class toggle, it's permanently dark-themed, so a
 * conditional `dark:prose-invert` never activates and renders unreadable
 * near-black text on the dark background. */
export const MarkdownText = ({ children, className = "" }) => {
  if (!children) return null;
  return (
    <div
      className={`prose prose-sm prose-invert max-w-none prose-p:my-2 prose-p:text-slate-200 prose-headings:mt-4 prose-headings:mb-2 prose-headings:font-bold prose-headings:text-white prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5 prose-li:text-slate-200 prose-hr:my-4 prose-strong:text-white prose-strong:font-semibold ${className}`}
      data-testid="markdown-text"
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
